import { Popper, Popover, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Switch from "@mui/material/Switch";
// import Box from "@mui/material/Box";
// import Tab from "@mui/material/Tab";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";

import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import "./index.scss";
import {
  getEsgLogin,
  getGeccoLogin,
  getUserIdFromStorage,
} from "common/utils/utilities";
import {
  getUserNotificationById,
  updateNotificationStatus,
} from "services/UserManagementServices";
import { timePassedSinceEvent } from "common/constants/constants";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const NotificationCenter = () => {
  let navigate = useNavigate();
  const userId = getUserIdFromStorage();
  const [isScrolling, setIsScrolling] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const { t } = useTranslation()
  // const [pageSize, setPageSize] = useState(5);
  const [notificationLists, setNotificationList] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);
  const [show, setShow] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [totalPage, setTotalPage] = useState(1);
  const [isMyClient, setIsMyClient] = useState("");
  let role = JSON.parse(localStorage.getItem("userRole"))?.roleName;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (role == "#EC" || role == "#EA") {
      getNotification();
    }
  }, [pageNumber, isMyClient]);

  const getNotification = async () => {
    let result = await getUserNotificationById(
      userId,
      pageNumber,
      20,
      isMyClient
    );
    if (result) {
      if (isScrolling) {
        setNotificationList([...notificationLists, ...result?.items]);
        setNotificationCount(result?.notificationCount);
      } else {
        setNotificationList(result?.items);
        setIsScrolling(false);
        setNotificationCount(result?.notificationCount);
      }
      setTotalPage(result?.totalPages);
    }
  };
  const updateStatus = async (Id) => {
    let list = [];
    list.push(Id);
    let result = await updateNotificationStatus(userId, {
      notificationId: list,
    });
    if (result) {
      getNotification();
    }
  };

  useEffect(() => {
    const node = document.querySelector(
      ".css-1peujwk-MuiPaper-root-MuiPopover-paper"
    );
    console.log('node', node)
    if (node) {
      node.addEventListener("scroll", () => {
        const perc =
          (node.scrollTop / (node.scrollHeight - node.clientHeight)) * 100;
        console.log('node', perc)

        if (perc >= 80) {
          if (pageNumber <= totalPage) {
            setPageNumber(() => pageNumber + 1);
            setIsScrolling(true);
          }
        }
      });
    } else {
      console.log('node issue else')
    }
  });
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div
      className="notfication-center"
      style={{ display: role == "#EC" || role == "#EA" ? "block" : "none" }}
    >
      <Button
        aria-describedby={id}
        variant="contained"
        onClick={handleClick}
        style={{ position: "relative" }}
      >
        <span className="count">{notificationCount}</span>
        <img src="/assets/icons/bell.svg" alt="icon" />
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Paper
          className="cutom-popover"
          sx={{
            width: 600,
            padding: "31px 12px 10px 41px",
            height: "70vh",
            boxShadow: "none",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h3 className="notification-heading">{t('notifications')}</h3>
            </div>
            <div>
              <span>{t("clients")}</span>
              <Switch
                color="secondary"
                onChange={(e) => {
                  setIsScrolling(false);
                  setPageNumber(1);
                  if (e.target.checked) {
                    setIsMyClient(true);
                  } else {
                    setIsMyClient("");
                  }
                }}
              />
            </div>
          </div>
          <div>
            <Tabs defaultActiveKey="home">
              <Tab eventKey="home" title={t("esg-ques")}>
                {notificationLists?.length > 0 ? (
                  <div className="notification-list">
                    <p className="latest">{t("latest")}</p>
                    {notificationLists?.map((notification, index) => {
                      return (
                        <div
                          // style={{ cursor: "pointer !important" }}
                          key={index}
                          className="notification-item"
                          onClick={() => {
                            updateStatus(notification?.notificationId);
                            navigate(
                              `/user-management/detail/${notification?.userId}`
                            );
                          }}
                          style={{
                            background: `${notification?.status == "READ"
                              ? ""
                              : "rgba(201, 241, 229, 0.51)"
                              }`,
                          }}
                        >
                          <div
                            style={{
                              marginLeft: `${notification?.status == "READ" ? "25px" : "0px"
                                }`,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  alignItems: "baseline",
                                }}
                              >
                                {notification?.status != "READ" ? (
                                  <img
                                    src="/assets/icons/circle.svg"
                                    alt="icon"
                                  />
                                ) : (
                                  ""
                                )}
                                <h3 className="title">{t("questionnaires-sent")}</h3>
                              </div>
                              <div className="time">
                                {timePassedSinceEvent(notification?.createdAt)}
                              </div>
                            </div>
                            <p
                              className="description"
                              style={{
                                paddingLeft: `${notification?.status == "READ"
                                  ? "0px"
                                  : "25px"
                                  }`,
                              }}
                              dangerouslySetInnerHTML={{
                                __html: notification?.message + `${t('sentAQues')}`,
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      flexDirection: "column",
                      height: "400px",
                    }}
                  >
                    <img
                      width={66}
                      height={66}
                      src="/assets/icons/bell.png"
                      alt="bell"
                    />
                    <p
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "gray",
                        paddingTop: "10px",
                      }}
                    >
                      {t("read-not")}
                    </p>
                  </div>
                )}
              </Tab>
            </Tabs>
          </div>
        </Paper>
      </Popover>
    </div>
  );
};

export default NotificationCenter;
